// PDF预加载工具
class PdfPreloader {
  constructor() {
    this.isPreloaded = false
    this.preloadPromise = null
  }

  // 预加载PDF相关资源
  async preload() {
    if (this.isPreloaded) {
      return
    }

    if (this.preloadPromise) {
      return this.preloadPromise
    }

    this.preloadPromise = this._doPreload()
    return this.preloadPromise
  }

  // 执行预加载
  async _doPreload() {
    try {
      // 预加载PDF组件和样式
      await Promise.all([
        // 预加载组件（但不执行）
        import('vue-pdf-embed'),
        // 预加载样式
        import('vue-pdf-embed/dist/styles/annotationLayer.css'),
        import('vue-pdf-embed/dist/styles/textLayer.css')
      ])

      this.isPreloaded = true
      console.log('PDF组件预加载完成')
    } catch (error) {
      console.warn('PDF预加载失败:', error)
      // 预加载失败不影响正常使用
    }
  }

  // 检查是否已预加载
  isReady() {
    return this.isPreloaded
  }

  // 重置状态
  reset() {
    this.isPreloaded = false
    this.preloadPromise = null
  }
}

// 创建单例
const pdfPreloader = new PdfPreloader()

export default pdfPreloader

// 预加载函数
export const startPdfPreload = () => {
  // 使用 requestIdleCallback 在浏览器空闲时预加载
  if ('requestIdleCallback' in window) {
    requestIdleCallback(() => {
      pdfPreloader.preload()
    }, { timeout: 2000 })
  } else {
    // 降级方案：延迟1秒后预加载
    setTimeout(() => {
      pdfPreloader.preload()
    }, 1000)
  }
} 